export const needsConfirmation = (status: string) =>
  status === 'UNCONFIRMED' || status === 'FORCE_CHANGE_PASSWORD';
